import * as $ from "jquery";

(($: any) => {
    $(document).ready(() => {
        const datepicker = $(".elo-datepicker");
        if (datepicker.length === 0) {
            return;
        }
        datepicker.blur();
        datepicker.datepicker({
            changeYear: true,
            constrainInput: true,
            dateFormat: "d.m.yy",
            maxDate: new Date(),
        });

        let ctrlDown = false;
        const ctrlKey = 17;
        const cmdKey = 91;
        const cKey = 67;

        datepicker.keydown((e: KeyboardEvent) => {
            if (e.keyCode === ctrlKey || e.keyCode === cmdKey) {
                ctrlDown = true;
            }
            if (!ctrlDown || (e.keyCode !== cKey)) {
                e.preventDefault();
            }
        }).keyup((e: KeyboardEvent) => {
            if (e.keyCode === ctrlKey || e.keyCode === cmdKey) {
                ctrlDown = false;
            }
        });

        datepicker.on("cut paste", (e: Event) => {
            e.preventDefault();
        });
    });
})($);
